import { z } from 'zod';
import { userSchema } from './user.schema';
import i18next from 'i18next';

export const registerUserSchema = userSchema
  .extend({
    passwordConfirm: z.string().superRefine((data, ctx) => {
      if (!data) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: i18next.t('common:passwordConfirmRequired'),
        });
      }
    }),
  })
  .superRefine((data, ctx) => {
    if (data.password !== data.passwordConfirm) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['passwordConfirm'],
        message: i18next.t('common:passwordConfirmIncorrect'),
      });
    }
  });

export type TRegisterUserSchema = z.infer<typeof registerUserSchema>;
